import { useState, useCallback } from 'react';

/**
 * Hook to handle copying text to clipboard with temporary success state
 * @param resetDelay - Time in milliseconds before resetting copied state (default: 2000ms)
 * @returns Object with copied state and copyToClipboard function
 */
export const useCopyToClipboard = (resetDelay: number = 2000) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), resetDelay);
      return true;
    } catch (err) {
      console.error("Failed to copy:", err);
      setCopied(false);
      return false;
    }
  }, [resetDelay]);

  return { copied, copyToClipboard };
};
